module.exports = __webpack_public_path__ + "static/media/bg1.7e3bd3aa.jpg";